// eslint-disable-next-line import/no-unresolved
// import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'
/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils
export class GridSwitcher extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['button']
  }

  connectedCallback () {
    super.connectedCallback()

    // Only the relevant switcher to set a default value for the page.
    if (this.isMobileScreen && this.typeDesktop) return
    if (this.isDesktopScreen && this.typeMobile) return

    this.setupDefaultColumns()
  }

  setupListeners () {
    super.setupListeners()

    this.triggerColumnChange = this.triggerColumnChange.bind(this)
    this.onWindowResize = this.onWindowResize.bind(this)

    this.els.button.elements.forEach(itemEl => {
      this.listeners.add(itemEl, 'click', this.triggerColumnChange)
    })

    window.addEventListener('resize', debounce(this.onWindowResize, 200))
  }

  onWindowResize () {
    let didRestrictColumns = false

    // Make sure an acceptable number of columns for the screen size.
    if (this.isMobileScreen && this.columns > 2) {
      this.columns = this.mobileColumns[0]
      didRestrictColumns = true
    } else if (this.isDesktopScreen && this.columns < 2) {
      this.columns = this.desktopColumns[1]
      didRestrictColumns = true
    }

    // Only trigger a layout change if necessary.
    if (didRestrictColumns) {
      this.changeColumnVariable()
      this.setLocalStorage()
      this.updateUrl()
    }

    // Make sure the correct icon/text is showing regardless of any
    // column count restriction.
    this.setDefaultButtonIconOrText()

    this.setupCarousel()
  }

  triggerColumnChange () {
    this.prevColumns = this.columns

    this.toggleColumns()
    this.changeColumnVariable()
    this.setLocalStorage()
    this.toggleButtonIconOrText()
    this.updateUrl()

    this.setupCarousel()
    this.setPadding()
  }

  setupCarousel () {
    document
      .querySelectorAll('[data-product-card-el="slides"]')
      .forEach(sliderEl => {
        // eslint-disable-next-line new-cap, no-new
        new KeenSlider(
          sliderEl,
          {
            selector: '[data-product-card-el="slide"]',
            loop: true,
            mode: 'snap',
            defaultAnimation: {
              duration: config.defaultAnimation.duration,
            },
            dragSpeed: config.dragSpeed,
            slides: {
              perView: 1,
            },
          },
          [setInitialised()],
        )
      })
  }

  setPadding () {
    document.querySelectorAll('.prd-List_Item').forEach(el => {
      el.classList.remove('prd-List_Item-inset')

      if (el.offsetLeft === 0) el.classList.add('prd-List_Item-inset')
    })
  }

  toggleColumns () {
    if (this.typeDesktop) {
      this.columns =
        this.columns === this.desktopColumns[0]
          ? this.desktopColumns[1]
          : this.desktopColumns[0]
    } else {
      this.columns =
        this.columns === this.mobileColumns[0]
          ? this.mobileColumns[1]
          : this.mobileColumns[0]
    }
  }

  setupDefaultColumns () {
    this.columns = this.defaultColumns

    this.changeColumnVariable()
    this.setLocalStorage()
    this.setDefaultButtonIconOrText()
    this.updateUrl()

    this.setupCarousel()
  }

  changeColumnVariable () {
    this.prdListElem?.style.setProperty('--Grid_Columns', this.columns)
    this.prdListElem?.setAttribute('data-columns', this.columns)
  }

  setLocalStorage () {
    window.localStorage.setItem(this.storageName, this.columns)
  }

  setDefaultButtonIconOrText () {
    if (this.typeDesktop && this.els?.columns?.exists) {
      const altValue =
        this.columns === this.desktopColumns[0]
          ? this.desktopColumns[1]
          : this.desktopColumns[0]

      this.els.columns.element.textContent = altValue
    } else {
      const altValue =
        this.columns === this.mobileColumns[0]
          ? this.mobileColumns[1]
          : this.mobileColumns[0]

      this.els.icon.elements.forEach(el => {
        if (Number(el.dataset.showWhenColumns) === altValue) {
          el.style.display = ''
        } else {
          el.style.display = 'none'
        }
      })
    }
  }

  toggleButtonIconOrText () {
    if (this.typeDesktop && this.els?.columns?.exists) {
      this.els.columns.element.textContent = this.prevColumns
    } else {
      this.els.icon.elements.forEach(el => {
        el.style.display = el.style.display === 'none' ? '' : 'none'
      })
    }
  }

  updateUrl () {
    // Construct URLSearchParams object instance from current URL querystring.
    // eslint-disable-next-line compat/compat
    const queryParams = new URLSearchParams(window.location.search)

    // Set new or modify existing parameter value.
    queryParams.set('grid', this.columns)

    // Replace current querystring with the new one.
    history.replaceState(null, null, `?${queryParams.toString()}`)
  }

  get storageName () {
    return 'BAO-clc_num_columns'
  }

  get prdListElem () {
    return document.querySelector('[data-prd-list-clc]')
  }

  get desktopColumns () {
    return [3, 2]
  }

  get mobileColumns () {
    return [2, 1]
  }

  get defaultColumns () {
    let storedCols = Number(window.localStorage.getItem(this.storageName))

    if (storedCols === 0) {
      return this.typeDesktop ? this.desktopColumns[0] : this.mobileColumns[0]
    }

    // Make sure an acceptable number of columns for the screen size.
    if (window.innerWidth < 901 && storedCols > this.mobileColumns[0]) {
      // storedCols is larger than the maximum mobile columns.
      storedCols = this.mobileColumns[0]
    } else if (
      window.innerWidth >= 901 &&
      storedCols < this.desktopColumns[1]
    ) {
      // storedCols is smaller than the minimum desktop columns.
      storedCols = this.desktopColumns[1]
    }

    return storedCols
  }

  get isMobileScreen () {
    return window.innerWidth < 901
  }

  get isDesktopScreen () {
    return window.innerWidth >= 901
  }

  get typeMobile () {
    return !this.typeDesktop
  }

  get typeDesktop () {
    return this.type === 'desktop'
  }

  get type () {
    return this.els?.button?.element.dataset.gridSwitcherType
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
